import { DateFormat, t, Trans } from '@lingui/macro'
import { colors, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'react-emotion/macro'
import { IAccount } from 'shopify-payment-core'

import { AccountInternalNote } from '../atoms/AccountInternalNote'
import { AccountStatus } from '../atoms/AccountStatus'
import { Brick } from '../atoms/Brick'
import { InfoLine } from '../atoms/InfoLine'
import { i18n } from '../i18n'
import { AccountDeleteButton } from '../molecules/AccountDeleteButton'

interface IProps {
  account: IAccount
}

const FloatRight = styled.div`
  float: right;
  margin-bottom: 1rem;
`

export const AccountBasicInfo: React.FC<IProps> = ({ account }) => {
  return (
    <Brick admin={true} title={<Trans>Základní informace o účtu</Trans>}>
      <InfoLine label={i18n._(t`Stav`)}>
        <AccountStatus account={account} />
      </InfoLine>
      <InfoLine label={i18n._(t`Kontaktní email`)}>
        {account.contactEmail}
      </InfoLine>
      <InfoLine label={i18n._(t`Registrováno od`)}>
        <DateFormat value={new Date(account.createdAt)} />
      </InfoLine>
      {account.trialRemaining > 0 ? (
        <InfoLine label={i18n._(t`Zbývá trial plateb`)}>
          {account.trialRemaining}
        </InfoLine>
      ) : null}
      <br />
      <AccountInternalNote account={account} />
      <br />
      <br />
      <FloatRight>
        <AccountDeleteButton account={account} />
      </FloatRight>
      <br />
      <Typography variant="caption" style={{ color: colors.grey[500] }}>
        {i18n._(t`ID účtu`)}: {account.id}
      </Typography>
    </Brick>
  )
}
